import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const SpinningIcon = styled.span`
  display: inline-flex;
  animation: ${spin} 1s linear infinite;
  margin-right: 6px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  /* 모바일: 이미지 상단 + 콘텐츠 카드 하단 */
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;
    justify-content: flex-start;
    overflow: hidden;
  }
`;

const ImageArea = styled.div`
  flex: 1;
  align-self: stretch;
  overflow: hidden;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    height: 38vh;
  }
`;

const LeftLayout = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  /* 모바일: 이미지 위로 겹쳐 올라오는 둥근 흰색 카드 */
  @media (max-width: 768px) {
    justify-content: center;
    background-color: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    box-shadow: 0px -16px 32px 0px rgba(0, 0, 0, 0.08);
    margin-top: -20px;
    padding: 0 20px;
    position: relative;
    z-index: 1;
  }
`;

const StyledHello = styled.div`
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  color: #888d96;
  margin-top: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const StyledError = styled.div`
  font-size: 14px;
  color: #f55060;
  line-height: 20px;
  margin-top: 8px;
`;

export {
  Container,
  ImageArea,
  LeftLayout,
  StyledHello,
  StyledError,
  SpinningIcon,
};
